<template>
   <div class="col-md-6 pr-md-1">
      <div class="form-group clearfix mb-0">
         <label class="fancy-checkbox element-left">
            <input type="checkbox" @click="toggle" :checked="permissao.habilitado" v-model="permissao.habilitado">
            <span>{{ permissao.descricao }}</span>
         </label>
      </div>
   </div>
</template>

<script>

export default {
	name: 'Permissao',
   props: ['permissao'],
   methods: {
      toggle : function () {
         this.$emit('toggle', this.permissao.id)
      }
   }
}

</script>

<style scoped>

.row {
	margin: 0;
}

.row>div {
	padding: 0;
}

.form-check-input[type=checkbox] {
   height: 15px;
   width: 15px;
   margin-right: 12px;
   margin-left: 0;
}

img {
   padding: 2px !important;
   background-color: #fff !important;
}

.not-allowed {
   cursor: not-allowed !important;
   filter: grayscale(1);
}

</style>